var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"a-share-button",class:_vm.shareLink.externalLinkClass,attrs:{"href":_vm.link,"target":"_blank"}},[_c('i',{class:[("fa-" + (_vm.shareLink.iconLogo)), _vm.shareLink.externalLinkClass === 'mail'? 'fas':'fab']})])}
var staticRenderFns = []

export { render, staticRenderFns }